/* Core & libraries */
import React, { useContext, createContext, useState, useEffect } from "react";
import { initTimezone } from '../helpers/timezoneConfig';
import {DEFAULT_LOCALE} from "../constants/appConstants";
import {storageFactory} from "factory/storageFactory";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */

const UserContext = createContext({});
const UserUpdateContext = createContext({});

export function useUserContext() {
  return useContext(UserContext);
}

export function useUserUpdateContext() {
  return useContext(UserUpdateContext);
}

const localStore = storageFactory(() => localStorage);
const sessionStore = storageFactory(() => sessionStorage);

export function UserProvider({ children }) {

  const [user, setUser] = useState(null);

  useEffect(() => {
    initTimezone(user?.useBrowserTimeZone);
  }, [user?.useBrowserTimeZone]);

  //context can store also functions, such as setters within the context itself
  const setUserDetails = (userDetails) => {

    if (sessionStore.getItem("managedCompany") && !userDetails?.userInfo?.companyInfo && userDetails?.manageCompany === undefined) {
      userDetails = {
        ...userDetails,
        userInfo: {
          ...userDetails.userInfo,
          companyInfo: JSON.parse(sessionStore.getItem("managedCompany"))
        },
        manageCompany: true
      }
    }

    setUser({
      ...user,
      ...userDetails,
    });

    if (userDetails?.manageCompany) {
      sessionStore.setItem("managedCompany", JSON.stringify(userDetails?.userInfo?.companyInfo))
    } else if (userDetails?.manageCompany === false) {
      sessionStore.removeItem("managedCompany")
    }

    if((localStore.getItem("showAuthorisedCityUsersModal") !== "false") && userDetails?.userInfo?.showShellUsersModal) {
      localStore.setItem("showAuthorisedCityUsersModal", true);
    }
  };

  return (
    <UserContext.Provider value={user} displayName="UserStore">
      <UserUpdateContext.Provider value={ setUserDetails } displayName="UserUpdateStore">
        {children}
      </UserUpdateContext.Provider>
    </UserContext.Provider>
  );
}
